import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'
import { FIELD_ID } from '../components/CustomCode/NJAsbestos/njasbestos_constants'

const njasbestos = {
  service_rider_link: function service_rider_link(objectId, searchDetailId, searchData, location) {
    console.log('njasbestos.service_rider_link', objectId, searchDetailId, searchData, location)

    let component = ''
    const pathName = `/custom/njasbestos.service_rider?caseId=${objectId}&noPageTop=Y&source=${location.pathname}${location.search}`
    component = <Link to={pathName} target="_blank" data-cy="search-results-view-button-link"><Button data-cy="search-results-view-button" className={searchData} color="primary" size="sm">Service Rider</Button></Link>
 
    return component
  },
  format_hook: function format_hook(object, field, refListRow, columnContent) {
    console.log('njasbestos.format_hook', object, field, refListRow)

    let component = columnContent
    if (refListRow) {
      if(refListRow[1] === 'Client') {
        component = <span style={{ color: 'red' }}>{columnContent}</span>
      }
    } else if (object && object.data) {
      const defendantType =  object.data[FIELD_ID.case.defendantDetail.defendantType]
      if (defendantType && defendantType.name === 'Client') {
        component = <span style={{ color: 'red' }}>{columnContent}</span>
      }
    }

    return component
  },
  
}

export default njasbestos
